<template>
  <div>
    <Head title="Data Permohonan Beasiswa" />
    <h1 class="mb-8 text-2xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/scholar-applications">Permohonan Beasiswa</Link>
      <span class="font-medium text-indigo-400">/</span>
      {{ application.periode }}
    </h1>
    <div v-if="!statusInput" class="w-full mb-8 bg-white rounded-md shadow">
      <div class="flex justify-between w-full px-8 py-6 bg-gray-200">
        <h2 class="text-xl">Informasi Permohonan Beasiswa ({{ application.jenis }})</h2>
        <Button v-if="can('write permohonan beasiswa') && (application.status == 0 || application.status == 2) && isValid" type="button" class="btn-green" @click.prevent="kirim">
          <span><font-awesome-icon icon="fas fa-paper-plane" class="mr-2" />Kirim Permohonan Beasiswa</span>
        </Button>
      </div>
      <div class="flex w-full">
        <dl class="flex flex-wrap w-full p-6 leading-10 lg:w-1/2">
          <dt class="w-full lg:w-3/12">Periode Beasiswa</dt>
          <dd class="w-full lg:w-9/12">: {{ application.periode }}</dd>
          <dt class="w-full lg:w-3/12">NIM Pemohon</dt>
          <dd class="w-full lg:w-9/12">: {{ application.nim }}</dd>
          <dt class="w-full lg:w-3/12">Nama Pemohon</dt>
          <dd class="w-full lg:w-9/12">: {{ application.nama_pemohon }}</dd>
          <dt class="w-full lg:w-3/12">Nama Universitas</dt>
          <dd class="w-full lg:w-9/12">: {{ application.nama_universitas }}</dd>
          <dt class="w-full lg:w-3/12">Program Studi</dt>
          <dd class="w-full lg:w-9/12">: {{ application.nama_prodi }}</dd>
          <dt class="w-full lg:w-3/12">Pra-Sejahtera</dt>
          <dd class="w-full lg:w-9/12">: {{ application.is_prasejahtera }}</dd>
          <dt class="w-full lg:w-3/12">Berprestasi</dt>
          <dd class="w-full lg:w-9/12">: {{ application.is_berprestasi }}</dd>
        </dl>
        <div class="flex flex-wrap w-full p-6 leading-10 lg:w-1/2">
          <dt class="w-full lg:w-4/12">Jenis Kelamin</dt>
          <dd class="w-full lg:w-8/12">: {{ application.jenis_kelamin }}</dd>
          <dt class="w-full lg:w-4/12">Alamat</dt>
          <dd class="w-full lg:w-8/12">: {{ application.alamat }}</dd>
          <dt class="w-full lg:w-4/12">Telepon</dt>
          <dd class="w-full lg:w-8/12">: {{ application.telp }}</dd>
          <dt class="w-full lg:w-4/12">Penghasilan Orang Tua</dt>
          <dd class="w-full lg:w-8/12">: Rp. {{ $filters.formatNumber(application.penghasilan_orangtua) }}</dd>
          <dt class="w-full lg:w-4/12">Jumlah Tanggungan Orang Tua</dt>
          <dd class="w-full lg:w-8/12">: {{ application.jumlah_tanggungan_orangtua }} Orang</dd>
        </div>
      </div>
    </div>
    <div class="w-full bg-white rounded-md shadow">
      <div class="flex justify-between w-full px-8 py-6 bg-gray-200">
        <h2 class="text-xl">File Persyaratan</h2>
        <Button v-if="can('write permohonan beasiswa') && (application.status == 0 || application.status == 2)" type="button" class="btn-indigo" @click.prevent="statusInput = true">
          <span><font-awesome-icon icon="fas fa-plus" class="mr-2" />Tambah</span>
        </Button>
      </div>
      <div class="p-6">
        <ul class="mt-2 ml-4 list-disc">
          <li v-for="syarat in persyaratans" :key="syarat.id" :class="{ 'form-error': !fileTypes.includes(syarat.id), 'form-valid': fileTypes.includes(syarat.id) }">
            {{ syarat.nama }} <font-awesome-icon v-if="fileTypes.includes(syarat.id)" icon="fas fa-check" class="text-green-700" />
          </li>
        </ul>
      </div>
      <table v-if="!statusInput" class="w-full whitespace-nowrap">
        <thead>
          <tr class="font-bold text-left">
            <th class="px-6 pt-6 pb-4">Jenis File</th>
            <th class="px-6 pt-6 pb-4">Status Verifikasi</th>
            <th v-if="can('write permohonan beasiswa')" class="px-6 pt-6 pb-4 border-b">Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="file in application.files" :key="file.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="p-4 border-t">
              {{ file.persyaratan }}
            </td>
            <td class="p-4 text-center border-t">
              <ul>
                <li>
                  <span v-if="file.status == 0" class="px-4 py-2 text-sm bg-yellow-300 rounded-lg">Draft</span>
                  <span v-else-if="file.status == 1" class="px-4 py-2 text-sm bg-yellow-500 rounded-lg">Diajukan</span>
                  <span v-else-if="file.status == 2" class="px-4 py-2 text-sm bg-red-300 rounded-lg">Belum Memenuhi Syarat</span>
                  <span v-else-if="file.status == 3" class="px-4 py-2 text-sm bg-red-500 rounded-lg">Tidak Memenuhi Syarat</span>
                  <span v-else class="px-4 py-2 text-sm bg-green-500 rounded-lg">Disetujui</span>
                </li>
              </ul>
              <p class="mt-2 leading-4">{{ file.catatan_verifikasi }}</p>
            </td>
            <td v-if="can('write permohonan beasiswa')" class="w-px p-4 border-t">
              <Button v-if="file.status == 0 || file.status == 2" type="button" class="rounded-l btn-red-sm" title="Hapus" @click.prevent="destroy(file.id)">
                <font-awesome-icon icon="fas fa-trash" />
              </Button>
              <Button type="button" title="Lihat File" class="rounded-r btn-green-sm" @click.prevent="viewImage(file.file_path)">
                <font-awesome-icon icon="fas fa-magnifying-glass" />
              </Button>
            </td>
          </tr>
          <tr v-if="application.files.length === 0">
            <td class="px-6 py-4 border-t" :colspan="can('write permohonan beasiswa')? 3 : 2">Tidak ada data file persayaratan yang diupload.</td>
          </tr>
        </tbody>
      </table>
      <form v-if="statusInput" @submit.prevent="uploadFile">
        <div class="flex p-8 -mb-8 -mr-6">
          <div class="w-full pb-8 pr-6 lg:w-2/3">
            <label for="persyaratan_id" class="form-label">Jenis</label>
            <v-select v-model="form.persyaratan_id" :options="availablePersyaratans" :reduce="persyaratan => persyaratan.id" label="nama" placeholder="Pilih Jenis" />
            <div v-if="form.errors.persyaratan_id" class="form-error">{{ form.errors.persyaratan_id }}</div>
          </div>

          <div class="w-full pb-8 pr-6">
            <file-input v-model="form.file" :error="form.errors.file" class="w-full pb-8 pr-6 lg:w-1/2" type="file" accept="image/*" label="File Persyaratan" @remove="imageData = ''" @change="previewImage" />
            <div v-if="form.errors.file" class="form-error">{{ form.errors.file }}</div>
          </div>
        </div>
        <div class="flex items-center px-8 py-4 border-t border-gray-100 bg-gray-50">
          <Button type="button" class="btn-red" @click.prevent="reset">
            <font-awesome-icon class="mr-2" icon="fas fa-ban" />Batal
          </Button>
          <loading-button :loading="form.processing" class="ml-auto btn-green" type="submit">
            <font-awesome-icon class="mr-2" icon="fas fa-key" />Simpan
          </loading-button>
        </div>
        <div v-if="imageData.length > 0" class="w-full p-8">
          <h3 class="mb-4 text-lg">Preview File :</h3>
          <img class="preview" :src="imageData" />
        </div>
      </form>
    </div>
    <image-viewer :src="imageSource" :show-modal="showImage" @close="showImage = false" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import LoadingButton from '@/Shared/LoadingButton'
import ImageViewer from '../../Shared/ImageViewer.vue'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    FileInput,
    ImageViewer,
  },
  layout: Layout,
  props: {
    application: Object,
    persyaratans: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        scholar_application_id: this.application.id,
        persyaratan_id: null,
        file: null,
      }),
      imageData: '',
      statusInput: false,
      imageSource: '',
      showImage: false,
    }
  },
  computed: {
    fileTypes() {
      return this.application.files.map((file) => file.persyaratan_id)
    },
    isValid() {
      var validity = true

      for (let index = 0; index < this.persyaratans.length; index++) {
        const syarat = this.persyaratans[index]

        if(!this.fileTypes.includes(syarat.id)) {
          validity = false
          break
        }
      }
      return validity
    },
    // NEW: Computed property to filter out already uploaded requirements
    availablePersyaratans() {
      // Get an array of IDs from the files that have already been uploaded.
      const uploadedFileIds = this.application.files.map(file => file.persyaratan_id);
      // Filter the main 'persyaratans' list to exclude any that have an ID in 'uploadedFileIds'.
      return this.persyaratans.filter(syarat => !uploadedFileIds.includes(syarat.id));
    },
  },

  methods: {
    previewImage: function(event) {
      // Reference to the DOM input element
      var input = event.target
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader()
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData = e.target.result
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0])
      }
    },
    reset() {
      this.statusInput = false
      this.form.persyaratan_id = null
      this.form.file =null
      this.imageData = ''
    },
    uploadFile() {
      this.form.post('/scholar-application-files', {
        onSuccess: () => {
          this.reset()
        },
      })
    },
    destroy(id) {
      this.$swal.fire({
        title: 'Anda yakin hapus data ini?',
        text: 'Anda tidak akan dapat mengembalikan data yang sudah dihapus!',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(`/scholar-application-files/${id}`)
        }
      })
    },
    kirim() {
      this.$swal.fire({
        title: 'Anda yakin kirim permohonan beasiswa ini?',
        text: 'Pastikan informasi yang anda kirimkan sudah sesuai!',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.put(`/scholar-applications/${this.application.id}/send`)
        }
      })
    },
    viewImage(imgSource) {
      this.imageSource = imgSource
      this.showImage = true
    },
  },
}
</script>
<style scoped>
 .vuejs3-datepicker__value {
  width: 100%;
  border-color: rgba(226, 232, 240, var(--tw-border-opacity));
}
</style>
